// Make a value ready for JSON.stringify() / process.send()
export class ErrorSerializer {
    public static Serialize(value) {
        if (typeof value === 'object') {
            return ErrorSerializer.destroyCircular(value, []);
        }

        // People sometimes throw things besides Error objects, so...

        if (typeof value === 'function') {
            // JSON.stringify discards functions. We do to, unless a function is thrown directly.
            return '[Function: ' + (value.name || 'anonymous') + ']';
        }

        return value;
    };

    // https://www.npmjs.com/package/destroy-circular
    private static destroyCircular(from, seen) {
        var to;
        if (Array.isArray(from)) {
            to = [];
        } else {
            to = {};
        }

        seen.push(from);

        Object.keys(from).forEach(function (key) {
            var value = from[key];

            if (typeof value === 'function') {
                return;
            }

            if (!value || typeof value !== 'object') {
                to[key] = value;
                return;
            }

            if (seen.indexOf(from[key]) === -1) {
                to[key] = ErrorSerializer.destroyCircular(from[key], seen.slice(0));
                return;
            }

            to[key] = '[Circular]';
        });

        if (typeof from.name === 'string') {
            to.name = from.name;
        }

        if (typeof from.message === 'string') {
            to.message = from.message;
        }

        if (typeof from.stack === 'string') {
            to.stack = from.stack;
        }

        let errorEventProps = ["message", "filename", "lineno", "colno", "error"]
        errorEventProps.forEach(prop => {
            if (typeof from[prop] === 'string' ||
                typeof from[prop] === 'number') {
                to[prop] = from[prop];
                return;
            }

            if (typeof from[prop] === 'object') {
                to[prop] = ErrorSerializer.Serialize(from[prop]);
            }
        })

        return to;
    }
}
